import waitReject from './waitReject';
export default function rejectAfter(promise, duration, reason) {
    if (!promise) {
        return;
    }
    if (!duration) {
        return promise;
    }
    const rejectPromise = waitReject(duration, reason);
    return Promise.race([
        promise.then((result) => {
            rejectPromise.resolve?.();
            return result;
        }),
        rejectPromise,
    ]);
}
